<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zouyuping
 * @Date: 2022-04-11 09:43:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-16 09:28:14
-->
<template>
  <div class="c-p-t-30">
    <van-cell-group inset>
      <van-cell title="退款商品" :value="item.Details[0].ProductName" />
      <van-cell title="退款数量" :value="item.Details[0].Quantity" />
      <van-cell title="退款金额" :value="item.Amount" />
      <van-cell title="退款账户" value="微信支付账户" />
      <van-cell
        title="到账时间"
        :value="item.CloseTime || '预计1-7个工作日内到账'"
      />
    </van-cell-group>
    <!-- <div class="c-f-bt c-m-30 c-ft-26">
      <div></div>
      <div>数量 x{{ item.Details[0].Quantity }}</div>
    </div> -->
    <gLine></gLine>
    <gTitle t="退款流程" class="c-m-30"></gTitle>
    <drawStep v-if="Object.keys(item).length > 0" :item="item"></drawStep>
  </div>
</template>

<script>
import drawStep from "./comps/drawStep";
export default {
  name: "DrawbackDetail",
  props: {},
  data() {
    return {
      id: "",
      aData: {},
      refundDetail: [],
      item: {},
      active: 1,
    };
  },
  components: {
    drawStep,
  },
  async created() {
    this.id = this.$route.params.id;
    this.getRefundDetail();
  },
  mounted() {},
  methods: {
    // 获取退单详情
    getRefundDetail() {
      return new Promise((r, j) => {
        $http(`wechath5/zh-cn/v1/refund?query.id=${this.id}`).then((res) => {
          this.item = res.Items[0];
        });
      });
    },
  },
};
</script>
<style scoped lang="scss"></style>
